import { createFileRoute } from "@tanstack/react-router";
import DeleteAccount from "@/pages/legal/DeleteAccount";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/delete-account/")({
  head: () => routeHead("/delete-account/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <DeleteAccount />
  );
}
